import { connect } from 'react-redux';

import { getMetainf, getProjectZoneId } from '../../../reducers/analyticsApp';
import { extractTypeFor } from '../../../utils/common';
import CompoundExecutionStepFilterFieldValues from '../../../components/compound/execution/StepFilterFieldValues';

const mapStateToProps = (state, { event, field, value }) => ({
  value,
  type: extractTypeFor(field, getMetainf(state, event)),
  zoneId: getProjectZoneId(state),
});

export default connect(mapStateToProps)(CompoundExecutionStepFilterFieldValues);
